import { IThreeDSecureProviderContractCreate } from './three-d-secure-provider-contract-create.interface';
// eslint-disable-next-line no-restricted-imports
import { EntityStatus, IEntity } from '@portal/entity-services/interfaces';

interface IThreeDSecureProviderContractResponseTemplate
  extends IThreeDSecureProviderContractCreate {
  contractUid: string;
  createdDate: Date;
  modifiedDate?: Date;
  version: number;
  status?: EntityStatus;
  objectType?: '3DS';
}

export interface IThreeDSecureProviderContractResponse
  extends IThreeDSecureProviderContractResponseTemplate {
  entityUid: string;
  entityName: string;
}

export interface IThreeDSecureProviderContractEntityResponse
  extends IThreeDSecureProviderContractResponseTemplate {
  entity: IEntity;
}

export type IThreeDSecureProviderContract =
  | IThreeDSecureProviderContractResponse
  | IThreeDSecureProviderContractEntityResponse;
